// extracted by mini-css-extract-plugin
module.exports = {"label":"BetaLabel_label__3C6U6"};